export default __webpack_public_path__ + "static/media/icon_calculator_solid.deeaf770.svg";